import Moment from 'moment';
/** Handles initialVisibleMonth prop passed in by user and
 *  the month selection after a filter is selected.
 *  @returns instanceof Moment based on above.
 */

export var getInitialVisibleMonth = function getInitialVisibleMonth(state, props) {
  var startDate = state.startDate,
      endDate = state.endDate,
      _state$selectedFilter = state.selectedFilterButtonName,
      selectedFilterButtonName = _state$selectedFilter === void 0 ? '' : _state$selectedFilter,
      selectedFilterIdx = state.selectedFilterIdx;
  var initialVisibleMonth = props.initialVisibleMonth,
      numberOfMonths = props.numberOfMonths;
  var curDay = Moment().startOf('day');
  var isMobile = typeof selectedFilterIdx === 'number';
  var mobileConditionBaseline = isMobile && selectedFilterIdx > -1;
  var bothMonthsSet = endDate && startDate && mobileConditionBaseline;
  var notMobileConditionBaseline = !isMobile && selectedFilterButtonName.length > 0;
  var is2MonthView = numberOfMonths === 2 && endDate && startDate && notMobileConditionBaseline;

  if ((bothMonthsSet || is2MonthView) && Moment(startDate).isBefore(curDay)) {
    return Moment(endDate).subtract(1, 'month');
  } else if ((bothMonthsSet || is2MonthView) && Moment(endDate).isAfter(curDay)) {
    return startDate;
  } else if (mobileConditionBaseline || notMobileConditionBaseline) {
    return endDate || curDay;
  }

  if (typeof initialVisibleMonth === 'function') {
    return initialVisibleMonth();
  }

  return startDate || curDay;
};
export default getInitialVisibleMonth;